@if (smallButton$ | async) {
  <button
    type="button"
    class="now-btn now-btn-secondary now-btn-icon-only now-icon-pencil text-nowrap"
    [title]="label"
    (click)="resetEmitted.emit()"
  ></button>
} @else {
  <button
    type="button"
    class="now-btn now-btn-secondary now-btn-icon now-icon-pencil text-nowrap"
    (click)="resetEmitted.emit()"
    [title]="label"
  >
    Bearbeiten
  </button>
}
